import { settings as settings } from '../environments/settings';
export const environment = {
  ...settings,
  template: 'nexi-1.0',
  theme: {
    name: 'BigMountainLodge',
    appName: 'Big Mountain Lodge',
    productionHostName: 'big-mountain-lodge',
    stagingHostName: 'qa-big-mountain-lodge',
    stagingdevHostName: 'dev-big-mountain-lodge',
    appCode: 'POCO'
},
  generalConfig: {
    multiLanguage: false,
    multiRegion: false,
    cacheName: 'cache-bml',
    cacheVersion: '1.13',
    haveEvents: false,
    startIn: '/tabs/properties',
  },
  cms: {
    domainId: 1147,
    accountId: 1147,
    channelId: 1769,
    deviceId: 1070,
    formId: 0,
    postalCode: 46225,
    bandwangosPageId: 0,
    visitorCenterId: 0,
    main_coordinates: {
      latitude: settings.site.latitude,
      longitude: settings.site.longitude,
    },
    navigation: {
      avatar_enabled: false,
      homePageId: 12364,
      homePageOptionsId: 12492,
      itemsPerRowCategory: 2
    }
  },
  regions:{
    enabled: false,
    regionsPageId: 0,
    defaultRegion: null
  },
  coreAuthLib: {
    base_url: 'https://usersapi.trueomni.com',
    client_secret: 'IA85H72hLsWWZcoE3UwSWN8m3',
    //client_secret: 'ZVS5f4khnUWbWoiWfVq9HQ',
  },
  firebase: {
    apiKey: "AIzaSyDc6gvWLJwQ_DfpdBQvRhOaApQjWj4Cd_g",
    authDomain: "big-mountain-lodge.firebaseapp.com",
    databaseURL: "https://big-mountain-lodge-default-rtdb.firebaseio.com",
    projectId: "big-mountain-lodge",
    storageBucket: "big-mountain-lodge.firebasestorage.app",
    messagingSenderId: "802294058875",
    appId: "1:802294058875:web:9a2a656ebfb49e086777de",
    measurementId: "G-6QX0SVYZFE"
  },
  messagesSDK: {
    // client_id: 1626,
    // client_secret: '7VaMnqxyqEGsVASD-r3rpQ',
    // VAPID_PUBLIC_KEY: 'BOrAnFUSkBX1g9hQoKn852lnuueQdtFKiR1V6XV4ss5HSzP7bSilDxmlq7TIbk0Lj2LCwOVrkltPmHkawI73wW0',
    // base_url: 'https://trueomni-notifications-qa.azurewebsites.net'
    client_id: 1639,
    client_secret: 'TlLe2k5gXUCsETs0kr3PgA',
    VAPID_PUBLIC_KEY: 'BGcSrEjzryK6m60lZi4J-WG3w-tqIw9wvqmYRucGpuuUvlyrFx5aSeitz473gTIUa0INzScSLvnr9lG_8JQ_2A4',
    base_url: 'https://trueomni-notifications.azurewebsites.net'
  },
  socialWall: {
    client_id: '',
    client_secret: '',
    url:''
  },
  googleMaps: 'AIzaSyAb0SnmmZsewjJYWVDY5U3D8-oo1zKh-Jg',
  google: {
    client_id: '802294058875-ep6f4bu7k9c16364lhkjlk77s0pjqaqg.apps.googleusercontent.com',
  },
  facebook: {
    app_id: '1467291388219796', // prod 1467291388219796 // qa 26002011482802691
    version: 'v25.0'
  },
  batuta: {
    api_key: 'e8e98196453d6f0bd4ffd6553d56a829',
    base_url: 'http://battuta.medunes.net/api/'
  },
  tokenUniversal: {
    token: "DWuAh7qPqHqyp8la7Os4568OuHLu6dbpyvo11ZtsIfPvAnQgZOEPQk9Ssqdlb42VqVI"
  },
  cloudbedsApi: {
    url: 'https://hos-api-qa.trueomni.com/api'
    //url: 'https://localhost:44315/'
  },

  ItineraryBuilder:{
    base_url: ''
  },
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
